/* eslint-disable no-unused-vars */
import { ControllerModel } from "../_model/ControllerModel";
import { SingletonFlowchart } from "../_service/singletonFlowchart";
import { Milling } from "./modelMilling";

class ControllerMilling extends ControllerModel {
  constructor(millingName) {
    super("ControllerMilling");
    
    this.setNewNode = (callback) => {
      let milling = new Milling(millingName);
      milling.decorate(callback);

      this.addNode(milling);
      SingletonFlowchart.SaveStatus()
    }

    this.loadNode = async (node, callback) => {
      let milling = new Milling(millingName);
      milling.copyFrom(node);
      await milling.decorate(callback);
      this.addNode(milling)
    }

    this.getProperties = async (node) => {
      let n = new Milling();
      await n.copyFrom(node);
      return n.data
    }

    this.getNode = (node) => {
      let n = new Milling();
      n.copyFrom(node);
      return n
    }
  }
}

export { ControllerMilling };
